import { css } from '@emotion/css'
import { spacing } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import { colors } from '../../../themes'

const styles = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: shorthandHelper([spacing.medium, 44]),
    borderBottom: `1px solid ${colors.catskillWhite}`,
  }),

  image: css({
    maxHeight: 90,
    marginBottom: spacing.small,
  }),
}

export default styles
